import React from 'react';
import styles from './styles.scss';

const DEFAULT_WIDTH = 320;

const Img = (props) => {
  const { src, alt, caption, sourceId, width: rawWidth } = props;

  const width = (() => {
    try {
      return parseInt(rawWidth, 10) || DEFAULT_WIDTH;
    } catch (e) {
      return DEFAULT_WIDTH;
    }
  })();

  return (
    <figure className={styles.layout} style={{ width }}>
      <img src={src} alt={alt} />
      {(caption || sourceId) && (
        <div className={styles.captionContainer}>
          {caption ? (
            <figcaption className={styles.caption}>{caption}</figcaption>
          ) : (
            <div />
          )}
          {sourceId && (
            <a
              className={styles.source}
              target="_blank"
              rel="noopener noreferrer"
              href={`https://docs.google.com/spreadsheets/d/1SMD0809T_ieKUM7UicaEvJ5rY7RqOUuba_bvRrdKjZ4/edit?usp=sharing#sourceId=${sourceId}`}
            >
              <i className="fad fa-at" />
            </a>
          )}
        </div>
      )}
    </figure>
  );
};

export default Img;
